<template>
  <div v-if="position.fixed_qty && +position.fixed_qty">
<!--    v-tooltip.left="$t('Purchase invoices')"-->
    <a v-if="canUsePurchaseInvoices"
       @click.prevent="getInvoicesData($event)"
       draggable="false"
       href="#"
       class="p-link table-link-icon">
      <i class="ti-link"/>
      <span class="qty">{{ +position.fixed_qty }}</span>
    </a>
    <span v-else class="table-link-icon">
      <i class="ti-link"/>
      <span class="qty">{{ +position.fixed_qty }}</span>
    </span>
    <OverlayPanel v-if="canUsePurchaseInvoices"
                  :ref="positionFixedQtyRef"
                  :autoZIndex="$store.state.firstLayerIsOpened">
      <Spinner v-if="isLoading" :isSmall="true" :spinnerStyle="'height:60px'"/>
      <div v-else class="overlay-panel-inner">
        <div v-if="fixedRequests?.length">
          <div class="title">{{ $t('Purchase invoices') }}:</div>
          <div v-for="(fixedRequest, index) of fixedRequests" :key="fixedRequest.id">
            <div v-if="fixedRequest.invoice_number && fixedRequest.uid">
              <router-link v-if="$store.getters.isAdminOrHigher"
                           :to="{ path: '/purchase-invoices', query: { show: fixedRequest.uid } }"
                           :target="settings.openAllLinksInSameTab ? '_self' : '_blank'"
                           rel="noopener">
                <span>{{ fixedRequest.invoice_number }}</span>
              </router-link>
              <span v-else>{{ fixedRequest.invoice_number }}</span>
              <div>{{$t('Qty')}}: {{ formatDecimal(fixedRequest.qty) }}</div>
            </div>
            <hr v-show="index < fixedRequests.length - 1">
          </div>
        </div>
        <div v-else>{{ $t('No data available') }}</div>
      </div>
    </OverlayPanel>
  </div>
</template>

<script>
import Spinner from "@/components/Spinner";
import httpClient from "@/services/http.services";
import showErrorsMixins from "@/mixins/showErrorsMixins";
import formatMixins from "@/mixins/formatMixins";
import billingFeaturesMixins from '@/mixins/billingFeaturesMixins'
import settings from "@/settings";

export default {
  name: 'PositionFixedQtyButton',
  mixins: [ showErrorsMixins, formatMixins, billingFeaturesMixins ],
  components: { Spinner },
  props: {
    fixedMode: {
      type: String,
      default: 'all', // all | request | return
    },
    position: {
      type: Object,
      required: true,
    },
  },
  inject: {
    positionMenusState: {
      default: () => ({
        activeKey: null,
      }),
    },
    openPositionMenu: {
      default: () => () => {},
    },
    closePositionMenus: {
      default: () => () => {},
    },
  },
  data() {
    return {
      isLoading: false,
      fixedRequests: null,
      settings
    }
  },
  watch: {
    'positionMenusState.activeKey'(activeKey) {
      if (activeKey !== this.positionFixedQtyMenuKey) {
        this.$refs[this.positionFixedQtyRef]?.hide?.()
      }
    }
  },
  methods: {
    async getInvoicesData($event) {
      if (!this.canUsePurchaseInvoices || !this.position?.id) return

      let orderPositionId = this.position.id
      let reducedPositionId = null

      if (this.fixedMode === 'return') {
        orderPositionId = this.position.order_position_id
        reducedPositionId = this.position.id
      }

      if (this.fixedMode === 'request' && !orderPositionId) return
      if (this.fixedMode === 'return' && !reducedPositionId) return
      if (this.fixedMode === 'all' && !orderPositionId && !reducedPositionId) return

      this.openPositionMenu(this.positionFixedQtyMenuKey)
      this.toggleFixedRequestsOverlay($event, this.position.id)

      if (!this.$refs[this.positionFixedQtyRef]?.visible) return false

      this.fixedRequests = null
      this.isLoading = true

      const apiLink = 'purchase-invoice/get-fixed-request-positions'

      const payload = {
        mode: this.fixedMode,
        orderPositionId,
        reducedPositionId
      }

      try {
        const { data, status } = await httpClient.post(apiLink, payload)

        if (status === 200 && data?.success) {
          this.fixedRequests = data.fixed_requests ?? null
        } else {
          this.showUnknownError()
          this.fixedRequests = null
        }
      } catch (err) {
        this.fixedRequests = null
        this.showError(err)
      } finally {
        this.isLoading = false
      }
    },
    toggleFixedRequestsOverlay(event, id) {
      if (!event || !id) return false
      this.$refs[this.positionFixedQtyRef]?.toggle?.(event)
    },
  },
  computed: {
    positionFixedQtyMenuKey() {
      return `position-fixed-qty-${this.position?.id}`
    },
    positionFixedQtyRef() {
      return 'ppio-' + this.position?.id
    },
  },
}
</script>

<style lang="scss" scoped>
.overlay-panel-inner {
  min-width: 110px!important;
  line-height: 1.4;
}
.title {
  padding-bottom: 10px;
  font-weight: 500;
}
.qty {
  font-size: 0.9em;
  //position: relative;
  //top: -1px;
  margin-left: 1px;
  font-variant-numeric: normal;
}
</style>